import { useEffect, useState } from 'react';
import { httpInterceptor } from '../../API/interceptor.jsx';
import { useNavigate, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { KeyConstant } from '../../utils/constants/keys.constants';

import './style.scss';
import 'react-datepicker/dist/react-datepicker.css';
import {
  addBeneficiary,
  getBeneficiary,
  getBeneficiaryById,
  getMunicipalities,
  getNeighborhoods,
  getZones
} from '../../API/apiService';

import Select from '../../components/select';
import { toast } from 'react-toastify';
import { useUserName } from '../../contexts/userName';

export default function Characterization() {
  const { userId } = useUserName();
  // STATES //
  const [personalAge, setPersonalAge] = useState('');
  const [personalInfo, setPersonalInfo] = useState({
    birthdate: '',
    fullName: '',
    gender: '',
    idNumber: 0,
    idType: '',
    address: '',
    municipality: '',
    municipalityName: '',
    zone: '',
    neighborhood: '',
    neighborhoodName: '',
    cellPhone: 0,
    personalEmail: '',
    scholarship: '',
    scholarshipValue: '',
    genderIdentity: '',
    genderIdentityValue: '',
    sexualOrientation: '',
    sexualOrientationValue: '',
    ethnicGroup: '',
    ethnicGroupValue: '',
    victimPopulation: '',
    victimPopulationValue: '',
    otherVictimValue: '',
    displacementTime: '',
    displacementPlace: '',
    disability: '',
    disabilityValue: '',
    chronicDisability: '',
    chronicDisabilityValue: '',
    risks: '',
    attendantName: '',
    attendantEmail: '',
    attendantPhone: '',
    maritalStatus: '',
    maritalStatusValue: '',
    organization: '',
    organizationValue: '',
    occupation: '',
    occupationValue: '',
    shirtSize: '',
    diseaseName: '',
    diseaseTreatment: '',
    userId: '',
    riskFactor: '',
    riskFactorValue: '',
    homeless: false,
    farmer: false,
    externalId: null,
    nationality: '',
  });
  const [typesId, setTypesId] = useState([]);
  const [gender, setGender] = useState([]);
  const [addressHead, setAddressHead] = useState([]);
  const [zones, setZones] = useState([]);
  const [schoolLevel, setSchoolLevel] = useState([]);
  const [genderIdentity, setGenderIdentity] = useState([]);
  const [sexualOrientation, setSexualOrientation] = useState([]);
  const [ethnicGroup, setEthnicGroup] = useState([]);
  const [victimPopulation, setVictimPopulation] = useState([]);
  const [disabilities, setDisabilities] = useState([]);
  const [risks, setRisks] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [organization, setOrganization] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [shirtSizes, setShirtSizes] = useState([]);
  const [municipalities, setMunicipalities] = useState([]);
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [isCheckedTerms, setIsCheckedTerms] = useState(false);
  const [edit, setEdit] = useState(false);

  const [age, setAge] = useState(0);
  const [addressComplement, setAddressComplement] = useState([]);
  const [addressStructure, setAddressStructure] = useState({});
  const [addressToShow, setAddressToShow] = useState('');

  const { paramValue, schoolParam, groupParam, bid } = useParams();
  const navigate = useNavigate();

  const diseases = [
    {
      id: 'Si',
      code: 'Si',
      value: 'Si'
    },
    {
      id: 'No',
      code: 'No',
      value: 'No'
    }
  ];

  const nationalityList = [
    {
      id: 'CO',
      code: 'COLOMBIANO',
      value: 'COLOMBIANO'
    },
    {
      id: 'VE',
      code: 'VENEZOLANO',
      value: 'VENEZOLANO',
    },
    {
      id: 'OT',
      code: 'OTRO',
      value: 'OTRO',
    }
  ];

  // METHODS //
  function save() {
    if (validateFields()) {
      personalInfo.userId = userId;
      httpInterceptor
        .post(`beneficiary`, personalInfo)
        .then(res => {
          if (res && res.success) {
            toast('Beneficiario Creado Satisfactoriamente', {
              type: 'success'
            });

            if (groupParam) {
              addToGroup(groupParam, res.data, schoolParam)
                .then(() =>
                  navigate(
                    `/escuelas/grupo/${groupParam}/school/${schoolParam}`
                  )
                )
                .catch(error => {
                  console.error(error);
                  toast('Beneficiario ya existe', {
                    type: 'error'
                  });
                });
            } else {
              navigate('/');
            }
          }
        })
        .catch(error => {
          if (error?.response?.data?.message?.code === '23505') {
            toast('Beneficiario ya existe', {
              type: 'error'
            });
          } else {
            toast('Error creando beneficiario', {
              type: 'error'
            });
          }
        });
    }
  }

  async function addToGroup(groupId, beneficiaryId, schoolId) {
    return await addBeneficiary(groupId, beneficiaryId, schoolId);
  }

  function validateEmail(value) {
    if (!value) {
      return true;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(value);
  }

  function validatePhone(value) {
    const emailRegex = /^[0-9]{10,}$/;
    return emailRegex.test(value);
  }

  function validateFields() {
    let isValid = false;
    if (!personalInfo.idType) {
      toast('Por favor seleccione un tipo de identificación', {
        type: 'warning'
      });
      return isValid;
    }
    if (!personalInfo.idNumber) {
      toast('Por favor digíta el número de identificación', {
        type: 'warning'
      });
      return isValid;
    }
    if (!personalInfo.fullName || personalInfo.fullName.length < 3) {
      toast('Por ingresa un nombre válido', {
        type: 'warning'
      });
      return isValid;
    }
    if (!personalInfo.address || personalInfo.address.length < 4) {
      toast('Por ingresa una direccion válida', {
        type: 'warning'
      });
      return isValid;
    }
    if (personalInfo.address === KeyConstant.ALTERNATIVE_ADDRESS) {
      toast('Por ingresa un nombre y descripción de la Vereda', {
        type: 'warning'
      });
      return isValid;
    }
    if (!personalInfo.fullName || personalInfo.fullName.length < 3) {
      toast('Por ingresa un nombre válido', {
        type: 'warning'
      });
      return isValid;
    }

    if (!validateEmail(personalInfo.personalEmail)) {
      toast('Debes ingresar un email válido', {
        type: 'warning'
      });
      return isValid;
    }

    if (!validatePhone(personalInfo.cellPhone)) {
      toast('Debes ingresar un celular válido', {
        type: 'warning'
      });
      return isValid;
    }

    const mandatoryFields = [
      { id: 'gender', name: 'sexo' },
      { id: 'gender', name: 'Género' },
      {
        id: 'birthdate',
        name: 'Fecha de nacimiento'
      },
      { id: 'zone', name: 'Zona' },
      { id: 'municipality', name: 'Comuna' },
      {
        id: 'neighborhood',
        name: 'Barrio'
      },
      { id: 'cellPhone', name: 'Celular' },
      {
        id: 'scholarship',
        name: 'Nivel de Escolaridad'
      },
      { id: 'victimPopulation', name: 'Población víctima' },
      { id: 'ethnicGroup', name: 'Etnia' },
      {
        id: 'disability',
        name: 'Condición de discapacidad'
      },
      { id: 'riskFactor', name: 'Factores de riesgo' }
    ];

    if (
      personalInfo.victimPopulation === KeyConstant.SOCIAL_VIOLENCE_KEY &&
      (!personalInfo.displacementTime || !personalInfo.displacementPlace)
    ) {
      toast('Debes ingresar un el tiempo y el lugar de desplazado', {
        type: 'warning'
      });
      return isValid;
    }

    if (
      personalInfo.victimPopulationValue === KeyConstant.ANOTHER_OPTION &&
      !personalInfo.otherVictimValue
    ) {
      toast('Debes ingresar la información de Población Víctima', {
        type: 'warning'
      });
      return isValid;
    }
    if (!personalInfo.chronicDisability) {
      toast('Tiene alguna enfermedad crónica?', {
        type: 'warning'
      });
      return isValid;
    } else if (
      personalInfo.chronicDisability === KeyConstant.OPTION_A &&
      (!personalInfo.diseaseName || !personalInfo.diseaseTreatment)
    ) {
      toast('Debes ingresar la enfermedad y su tratamiento', {
        type: 'warning'
      });
      return isValid;
    }

    if (age < 14) {
      mandatoryFields.push({ id: 'attendantName', name: 'Acudiente' });
      mandatoryFields.push({
        id: 'attendantPhone',
        name: 'Celular de Acudiente'
      });
    } else {
      mandatoryFields.push({ id: 'maritalStatus', name: 'Estado Civil' });
      mandatoryFields.push({ id: 'occupation', name: 'Ocupación' });
      mandatoryFields.push({
        id: 'sexualOrientation',
        name: 'Orientacion Sexual'
      });
      mandatoryFields.push({
        id: 'genderIdentity',
        name: 'Identidad de Género'
      });
      mandatoryFields.push({ id: 'organization', name: 'Organización' });
    }
    if (age < 18) {
      mandatoryFields.push({ id: 'shirtSize', name: 'Talla camiseta' });
    }
    if (!isCheckedTerms) {
      toast('Debes Aceptar las políticas de tratamiento de datos', {
        type: 'warning'
      });
      return isValid;
    }
    isValid = true;
    mandatoryFields.forEach(m => {
      const idName = personalInfo[`${m.id}`];
      if (!idName || idName?.toString()?.indexOf('Seleccione') !== -1) {
        toast(`El campo ${m.name} es obligatorio`, {
          type: 'warning'
        });
        isValid = false;
      }
    });
    return isValid;
  }

  function getLists() {
    httpInterceptor.get(`/lists`).then(res => {
      let data = [];
      if (res?.status === 200) {
        data = res.data.data;
      } else if (res && res.success) {
        data = res.data;
      }
      const typeId = data.filter(item => item.type === 'identification_type');
      if (typeId && typeId.length > 0) {
        setTypesId(
          typeId.map(t => {
            return { id: t.code, value: t.value };
          })
        );
      }

      const gender = data.filter(item => item.type === 'gender');
      setGender(gender);

      const addressHead = data.filter(item => item.type === 'address_format');
      setAddressHead(addressHead);

      setAddressComplement([
        { id: 'Norte', value: 'Norte' },
        { id: 'Sur', value: 'Sur' },
        {
          id: 'Este',
          value: 'Este'
        },
        { id: 'Oeste', value: 'Oeste' }
      ]);

      const schoolLevel = data.filter(item => item.type === 'schooling_level');
      setSchoolLevel(schoolLevel);

      const genderId = data.filter(item => item.type === 'gender_identity');
      setGenderIdentity(genderId);

      const s = data.filter(item => item.type === 'sexual_orientation');
      setSexualOrientation(s);

      const ethnicGroup = data.filter(item => item.type === 'ethnic_group');
      setEthnicGroup(ethnicGroup);

      const victims = data.filter(item => item.type === 'victim_population');
      setVictimPopulation(victims);

      const disability = data.filter(item => item.type === 'disability');
      setDisabilities(disability);

      const r = data.filter(item => item.type === 'risk_factor');
      setRisks(r);

      const ms = data.filter(item => item.type === 'marital_status');
      setMaritalStatus(ms);

      const org = data.filter(item => item.type === 'organization');
      setOrganization(org);

      const occupations = data.filter(item => item.type === 'occupation');
      setOccupation(occupations);

      const shirtSizeList = data.filter(item => item.type === 'shirt_size');
      setShirtSizes(shirtSizeList);
    });
    return () => {};
  }

  function addPersonalInfo(param, value, relatedValue) {
    const valueName = `${param}Value`;
    if (personalInfo[valueName] !== undefined) {
      setPersonalInfo({
        ...personalInfo,
        [param]: value,
        [valueName]: relatedValue
      });
    } else {
      setPersonalInfo({ ...personalInfo, [param]: value });
    }
  }

  async function getBeneficiaryInfo(documentNumber) {
    if (documentNumber) {
      const beneficiary = await getBeneficiary(documentNumber);
      // personalInfo.idNumber = documentNumber;
      setPersonalInfo({
        ...personalInfo,
        idNumber: documentNumber,
        idType: 'CC'
      });
      if (beneficiary) {
        updateBeneficiaryInfo(beneficiary);
      }
    }
  }

  async function getBeneficiaryByUID(id) {
    if (id) {
      const beneficiary = await getBeneficiaryById(id);
      updateBeneficiaryInfo(beneficiary);
    }
  }

  function updateBeneficiaryInfo(beneficiary) {
    let info = {};
    if (beneficiary) {
      setEdit(true);
      info = {
        address: beneficiary.address,
        attendantEmail: beneficiary.parent_email,
        attendantName: beneficiary.parent,
        attendantPhone: beneficiary.parent_phone,
        birthdate: beneficiary.birth_date,
        cellPhone: beneficiary.cellphone,
        chronicDisability: beneficiary.chronic_disability_value,
        disability: beneficiary.disability,
        disabilityValue: beneficiary.disability_value,
        diseaseName: beneficiary.disease_name,
        diseaseTreatment: beneficiary.disease_treatment,
        displacementPlace: beneficiary.displacement_place,
        displacementTime: beneficiary.displacement_time,
        ethnicGroup: beneficiary.ethnic_group,
        ethnicGroupValue: beneficiary.ethnic_group_value,
        externalId: beneficiary.id,
        farmer: beneficiary.farmer,
        fullName: beneficiary.full_name,
        gender: beneficiary.gender,
        genderIdentity: beneficiary.gender_identity,
        genderIdentityValue: beneficiary.gender_identity_value,
        homeless: beneficiary.homeless,
        idNumber: beneficiary.document,
        idType: beneficiary.document_type,
        maritalStatus: beneficiary.marital_status,
        maritalStatusValue: beneficiary.marital_status_value,
        municipality: beneficiary.municipality_id,
        municipalityName: beneficiary.municipality?.name,
        neighborhood: beneficiary.neighborhood_id,
        neighborhoodName: beneficiary.neighborhood?.name,
        occupation: beneficiary.occupation,
        occupationValue: beneficiary.occupation_value,
        organization: beneficiary.organization,
        organizationValue: beneficiary.organization_value,
        otherVictimValue: beneficiary.other_victim_value,
        personalEmail: beneficiary.email,
        riskFactor: beneficiary.risk_factor,
        riskFactorValue: beneficiary.risk_factor_value,
        scholarship: beneficiary.scholarship,
        scholarshipValue: beneficiary.scholarship_value,
        sexualOrientation: beneficiary.sexual_orientation,
        sexualOrientationValue: beneficiary.sexual_orientation_value,
        shirtSize: beneficiary.shirt_size,
        victimPopulation: beneficiary.victim_population,
        victimPopulationValue: beneficiary.victim_population_value,
        zone: beneficiary.zone_id,
        nationality: beneficiary.nationality
      };
      const birth = new Date(info.birthdate);
      setAddressToShow(info.address);
      setPersonalAge(birth);
      calculateAge(birth);
      setPersonalInfo(info);
    }
  }

  async function getBasicInfo() {
    getLists();
    const data = await getZones();
    if (data) {
      setZones(
        data.map(z => {
          return { id: z.id, value: z.name };
        })
      );
    }

    return () => {};
  }

  function calculateAge(birth) {
    let fullAge = 0;
    if (birth) {
      const now = new Date();
      const birthday = new Date(birth);
      if (birthday.getTime() > now.getTime()) {
        alert('Debe ingresar una fecha valida');
        return false;
      }
      fullAge = now.getFullYear() - birthday.getFullYear();
      const month = now.getMonth() - birthday.getMonth();
      if (month < 0 || (month === 0 && now.getDate() < birthday.getDate())) {
        fullAge--;
      }

      if (typeof fullAge === 'boolean') {
        if (!fullAge) {
          setPersonalInfo({ ...personalInfo, birthdate: '' });
          setAge(null);
          return;
        }
      }
      setPersonalInfo({ ...personalInfo, birthdate: birth });
      setAge(fullAge);
      setPersonalAge(birth);
    }
    return fullAge;
  }

  async function onChangeZone(param, value, relatedValue) {
    await updateMunicipalities(value);
    addPersonalInfo(param, value, relatedValue);
  }

  async function updateMunicipalities(selectedId) {
    const data = await getMunicipalities(selectedId);
    if (data) {
      setMunicipalities(
        data.map(m => {
          return { id: m.id, value: m.name };
        })
      );
    }
  }

  async function onChangeMunicipality(param, value, relatedValue) {
    await updateNeighborhoods(value);
    addPersonalInfo(param, value, relatedValue);
  }

  async function updateNeighborhoods(selectedId) {
    const data = await getNeighborhoods(selectedId);
    if (data) {
      setNeighborhoods(
        data.map(m => {
          return { id: m.id, value: m.name };
        })
      );
    }
  }

  function handleAddressChange(param, value, relatedValue) {
    const as = {
      ...addressStructure,
      [param]: relatedValue ?? value
    };
    setAddressStructure(as);
  }

  useEffect(() => {
    let finalAddress;
    if (addressStructure.streetType === KeyConstant.ALTERNATIVE_ADDRESS_CODE) {
      const { veredaName, veredaDescription } = addressStructure;
      finalAddress = `${KeyConstant.ALTERNATIVE_ADDRESS} ${veredaName} ${veredaDescription}`;
    } else {
      const { streetType, n1, l1, c1, n2, l2, c2, n3, type } = addressStructure;
      finalAddress = `${streetType ?? ''} ${n1 ?? ''}${l1 ?? ''} ${c1 ?? ''} ${
        n2 ? '#' : ''
      } ${n2 ?? ''}${l2 ?? ''} ${c2 ?? ''} ${n3 ? '-' : ''} ${n3 ?? ''}  ${
        type ?? ''
      }`;
    }
    addPersonalInfo('address', finalAddress);
    setAddressToShow(finalAddress);
  }, [addressStructure]);

  useEffect(() => {
    getBasicInfo();
  }, []);

  useEffect(() => {
    getBeneficiaryInfo(paramValue);
  }, [paramValue]);

  useEffect(() => {
    getBeneficiaryByUID(bid);
  }, [bid]);

  return (
    <main className='characterization'>
      <div className='characterization__container c-content'>
        <div className='c-content__header head'>
          <h2 className='head__title'>Caracterización</h2>
          <p className='head__subtitle'>Información del Beneficiario</p>
        </div>
        <div className='c-content__form form'>
          <div className='form__section section'>
            <div className='section__field field'>
              <span className='field__text'>
                Tipo de Identificación<p className='field__star'>*</p>
              </span>
              <Select
                field='idType'
                options={typesId}
                selectedDef={personalInfo?.idType}
                setSelected={(param, value, relatedValue) =>
                  addPersonalInfo(param, value, relatedValue)
                }></Select>
            </div>
            <div className='section__field field'>
              <span className='field__text'>
                N° de Identificación<p className='field__star'>*</p>
              </span>
              <input
                className='field__input'
                name='idNumber'
                placeholder=''
                type='number'
                value={personalInfo.idNumber}
                onInput={({ target }) =>
                  addPersonalInfo(target.name, target.value)
                }
              />
            </div>
            <div className='section__field field'>
              <span className='field__text'>
                Nombre Completo<p className='field__star'>*</p>
              </span>
              <input
                className='field__input'
                name='fullName'
                type='text'
                value={personalInfo.fullName}
                onInput={({ target }) =>
                  addPersonalInfo(target.name, target.value)
                }
              />
            </div>
            <div className='section__field field'>
              <span className='field__text'>
                Nacionalidad<p className='field__star'>*</p>
              </span>
              <Select
                  field='nationality'
                  options={nationalityList}
                  selectedDef={personalInfo?.nationality}
                  setSelected={(param, value, relatedValue) =>
                      addPersonalInfo(param, value, relatedValue)
                  }></Select>
            </div>
            <div className='section__field field'>
              <span className='field__text'>
                Sexo<p className='field__star'>*</p>
              </span>
              <Select
                field='gender'
                options={gender}
                selectedDef={personalInfo.gender}
                setSelected={(param, value, relatedValue) =>
                  addPersonalInfo(param, value, relatedValue)
                }></Select>
            </div>
            <div className='section__field field'>
              <span className='field__text'>
                Fecha de Nacimiento<p className='field__star'>*</p>
              </span>
              <DatePicker
                dateFormat='dd/MM/yyyy'
                selected={personalAge}
                className='field__input'
                showMonthDropdown
                useShortMonthInDropdown
                showYearDropdown
                dateFormatCalendar='MMMM'
                yearDropdownItemNumber={100}
                scrollableYearDropdown
                closeOnScroll={false}
                withPortal
                autoComplete='off'
                onChange={date => calculateAge(date)}
                placeholder='Seleccione'></DatePicker>
              <span className='field__text field__text--sub'>
                Edad: {age} años
              </span>
            </div>
          </div>
          {age < 18 && (
            <div className='form__section section'>
              <div className='section__field field'>
                <span className='field__text'>
                  Talla camiseta<p className='field__star'>*</p>
                </span>
                <Select
                  field='shirtSize'
                  options={shirtSizes}
                  selectedDef={personalInfo.shirtSize}
                  setSelected={(param, value, relatedValue) =>
                    addPersonalInfo(param, value, relatedValue)
                  }></Select>
              </div>
            </div>
          )}
          {age < 14 && (
            <div className='form__section section'>
              <div className='section__field field'>
                <span className='field__text'>
                  Nombre Completo del Acudiente<p className='field__star'>*</p>
                </span>
                <input
                  className='field__input'
                  name='attendantName'
                  autoComplete='off'
                  value={personalInfo.attendantName}
                  type='text'
                  onInput={({ target }) =>
                    addPersonalInfo(target.name, target.value)
                  }
                />
              </div>
              <div className='section__field field'>
                <span className='field__text'>
                  Celular del Acudiente<p className='field__star'>*</p>
                </span>
                <input
                  className='field__input'
                  type='text'
                  name='attendantPhone'
                  value={personalInfo.attendantPhone}
                  onInput={({ target }) =>
                    addPersonalInfo(target.name, target.value)
                  }
                />
              </div>
              <div className='section__field field'>
                <span className='field__text'>
                  Correo electrónico <p className='field__star'>*</p>
                </span>
                <input
                  className='field__input'
                  type='email'
                  name='attendantEmail'
                  placeholder='Ejm: example@example.com'
                  value={personalInfo.attendantEmail}
                  onInput={({ target }) =>
                    addPersonalInfo(target.name, target.value)
                  }
                />
              </div>
            </div>
          )}
          {age >= 14 && (
            <div className='form__section section'>
              <div className='section__field field'>
                <span className='field__text'>Estado Civil</span>
                <Select
                  field='maritalStatus'
                  options={maritalStatus}
                  selectedDef={personalInfo.maritalStatus}
                  setSelected={(param, value, relatedValue) =>
                    addPersonalInfo(param, value, relatedValue)
                  }></Select>
              </div>
              <div className='section__field field'>
                <span className='field__text'>
                  Organización a la que pertenece
                </span>
                <Select
                  field='organization'
                  options={organization}
                  selectedDef={personalInfo.organization}
                  setSelected={(param, value, relatedValue) =>
                    addPersonalInfo(param, value, relatedValue)
                  }></Select>
              </div>
              <div className='section__field field'>
                <span className='field__text'>Ocupación</span>
                <Select
                  field='occupation'
                  options={occupation}
                  selectedDef={personalInfo.occupation}
                  setSelected={(param, value, relatedValue) =>
                    addPersonalInfo(param, value, relatedValue)
                  }></Select>
              </div>
            </div>
          )}
          <div className='form__section section'>
            <div className='section__field field section__field--all-row'>
              <span className='field__text'>
                Dirección<p className='field__star'>*</p>
              </span>
              <input
                className='field__input field__input--disabled'
                disabled={true}
                type='text'
                value={addressToShow}
              />
            </div>
            <div className='section__field field section__field--all-row'>
              <span className='field__text'>
                Tipo de Via<p className='field__star'>*</p>
              </span>
              <Select
                field='streetType'
                options={addressHead}
                setSelected={(param, value, relatedValue) =>
                  handleAddressChange(param, value, relatedValue)
                }></Select>
            </div>
            {personalInfo.address
              .toLowerCase()
              .includes(KeyConstant.ALTERNATIVE_ADDRESS_CODE.toLowerCase()) ? (
              <>
                <div className='section__field field'>
                  <span className='field__text'>
                    Nombre de la Vereda<p className='field__star'>*</p>
                  </span>
                  <input
                    className='field__input'
                    type='text'
                    name='veredaName'
                    onInput={({ target }) =>
                      handleAddressChange(target.name, target.value)
                    }
                  />
                </div>
                <div className='section__field field'>
                  <span className='field__text'>
                    Descripción<p className='field__star'>*</p>
                  </span>
                  <input
                    className='field__input'
                    type='text'
                    name='veredaDescription'
                    onInput={({ target }) =>
                      handleAddressChange(target.name, target.value)
                    }
                  />
                </div>
              </>
            ) : (
              <>
                <div className='section__field field section__field--wrapper'>
                  <div className='section__field field'>
                    <span className='field__text'>
                      Número<p className='field__star'>*</p>
                    </span>
                    <input
                      className={
                        addressStructure.streetType
                          ? 'field__input'
                          : 'field__input field__input--disabled'
                      }
                      disabled={!addressStructure.streetType}
                      type='number'
                      name='n1'
                      onInput={({ target }) =>
                        handleAddressChange(target.name, target.value)
                      }
                    />
                  </div>
                  <div className='section__field field'>
                    <span className='field__text'>Letra</span>
                    <input
                      className={
                        addressStructure.n1
                          ? 'field__input'
                          : 'field__input field__input--disabled'
                      }
                      disabled={!addressStructure.n1}
                      type='text'
                      name='l1'
                      onInput={({ target }) =>
                        handleAddressChange(target.name, target.value)
                      }
                    />
                  </div>
                  <div className='section__field field'>
                    <span className='field__text'>Complemento</span>
                    <Select
                      field='c1'
                      options={addressComplement}
                      disabled={!addressStructure.n1}
                      setSelected={(param, value, relatedValue) =>
                        handleAddressChange(param, value, relatedValue)
                      }></Select>
                  </div>
                  <div className='section__field field'>
                    <span className='field__text'>
                      Número<p className='field__star'>*</p>
                    </span>
                    <input
                      className={
                        addressStructure.n1
                          ? 'field__input'
                          : 'field__input field__input--disabled'
                      }
                      disabled={!addressStructure.n1}
                      type='number'
                      name='n2'
                      onInput={({ target }) =>
                        handleAddressChange(target.name, target.value)
                      }
                    />
                  </div>
                  <div className='section__field field'>
                    <span className='field__text'>Letra</span>
                    <input
                      className={
                        addressStructure.n2
                          ? 'field__input'
                          : 'field__input field__input--disabled'
                      }
                      disabled={!addressStructure.n2}
                      type='text'
                      name='l2'
                      onInput={({ target }) =>
                        handleAddressChange(target.name, target.value)
                      }
                    />
                  </div>
                  <div className='section__field field'>
                    <span className='field__text'>Complemento</span>
                    <Select
                      field='c2'
                      options={addressComplement}
                      disabled={!addressStructure.n2}
                      setSelected={(param, value, relatedValue) =>
                        handleAddressChange(param, value, relatedValue)
                      }></Select>
                  </div>
                  <div className='section__field field'>
                    <span className='field__text'>
                      Número<p className='field__star'>*</p>
                    </span>
                    <input
                      className={
                        addressStructure.n2
                          ? 'field__input'
                          : 'field__input field__input--disabled'
                      }
                      disabled={!addressStructure.n2}
                      type='number'
                      name='n3'
                      onInput={({ target }) =>
                        handleAddressChange(target.name, target.value)
                      }
                    />
                  </div>
                  <div className='section__field field'>
                    <span className='field__text'>Apto / Local / Interior</span>
                    <input
                      className={
                        addressStructure.n2
                          ? 'field__input'
                          : 'field__input field__input--disabled'
                      }
                      disabled={!addressStructure.n2}
                      type='text'
                      name='type'
                      onInput={({ target }) =>
                        handleAddressChange(target.name, target.value)
                      }
                    />
                  </div>
                </div>
              </>
            )}

            <div className='section__field field'>
              <span className='field__text'>Zona</span>
              <Select
                field='zone'
                options={zones}
                selectedDef={personalInfo.zone}
                setSelected={(param, value, relatedValue) =>
                  onChangeZone(param, value, relatedValue)
                }></Select>
            </div>
            <div className='section__field field'>
              <span className='field__text'>Comuna</span>
              <Select
                field='municipality'
                options={municipalities}
                selectedDef={personalInfo.municipality}
                disabled={!personalInfo.zone}
                setSelected={(param, value, relatedValue) =>
                  onChangeMunicipality(param, value, relatedValue)
                }></Select>
            </div>
            <div className='section__field field'>
              <span className='field__text'>Barrio</span>
              <Select
                field='neighborhood'
                options={neighborhoods}
                selectedDef={personalInfo.neighborhood}
                disabled={!personalInfo.municipality}
                setSelected={(param, value, relatedValue) =>
                  addPersonalInfo(param, value, relatedValue)
                }></Select>
            </div>
            <div className='section__field field'>
              <span className='field__text'>
                Celular<p className='field__star'>*</p>
              </span>
              <input
                className='field__input'
                name='cellPhone'
                type='number'
                maxLength={10}
                value={personalInfo.cellPhone}
                onInput={({ target }) =>
                  addPersonalInfo(target.name, target.value)
                }
              />
            </div>
            <div className='section__field field'>
              <span className='field__text'>Correo electrónico</span>
              <input
                className='field__input'
                type='email'
                name='personalEmail'
                placeholder='Ejm: example@example.com'
                value={personalInfo.personalEmail}
                onInput={({ target }) =>
                  addPersonalInfo(target.name, target.value)
                }
              />
            </div>
          </div>
          <div className='form__section section'>
            <div className='section__field field'>
              <span className='field__text'>
                Nivel de Escolaridad<p className='field__star'>*</p>
              </span>
              <Select
                field='scholarship'
                options={schoolLevel}
                selectedDef={personalInfo.scholarship}
                setSelected={(param, value, relatedValue) =>
                  addPersonalInfo(param, value, relatedValue)
                }></Select>
            </div>
          </div>
          <div className='form__section section'>
            {age >= 14 && (
              <>
                <div className='section__field field'>
                  <span className='field__text'>
                    Identidad de Género<p className='field__star'>*</p>
                  </span>
                  <Select
                    field='genderIdentity'
                    options={genderIdentity}
                    selectedDef={personalInfo.genderIdentity}
                    setSelected={(param, value, relatedValue) =>
                      addPersonalInfo(param, value, relatedValue)
                    }></Select>
                </div>
                <div className='section__field field'>
                  <span className='field__text'>
                    Orientación Sexual<p className='field__star'>*</p>
                  </span>
                  <Select
                    field='sexualOrientation'
                    options={sexualOrientation}
                    selectedDef={personalInfo.sexualOrientation}
                    setSelected={(param, value, relatedValue) =>
                      addPersonalInfo(param, value, relatedValue)
                    }></Select>
                </div>
              </>
            )}
            <div className='section__field field'>
              <span className='field__text'>
                Etnia<p className='field__star'>*</p>
              </span>
              <Select
                field='ethnicGroup'
                options={ethnicGroup}
                selectedDef={personalInfo.ethnicGroup}
                setSelected={(param, value, relatedValue) =>
                  addPersonalInfo(param, value, relatedValue)
                }></Select>
            </div>
            <div className='section__field field'>
              <span className='field__text'>
                Población victima<p className='field__star'>*</p>
              </span>
              <Select
                field='victimPopulation'
                options={victimPopulation}
                selectedDef={personalInfo.victimPopulation}
                setSelected={(param, value, relatedValue) =>
                  addPersonalInfo(param, value, relatedValue)
                }></Select>
            </div>
            {personalInfo.victimPopulation === KeyConstant.ANOTHER_OPTION && (
              <div className='section__field field'>
                <span className='field__text'>Otra</span>
                <input
                  className='field__input'
                  name='otherVictim'
                  type='text'
                  value={personalInfo.otherVictimValue}
                  onInput={({ target }) =>
                    addPersonalInfo(target.name, target.value)
                  }
                />
              </div>
            )}
            {personalInfo.victimPopulation === KeyConstant.SOCIAL_VIOLENCE && (
              <>
                <div className='section__field field'>
                  <span className='field__text'>
                    Tiempo de desplazado (meses)<p className='field__star'>*</p>
                  </span>
                  <input
                    className='field__input'
                    type='number'
                    name='displacementTime'
                    value={personalInfo.displacementTime}
                    onInput={({ target }) =>
                      addPersonalInfo(target.name, target.value)
                    }
                  />
                </div>
                <div className='section__field field'>
                  <span className='field__text'>
                    Lugar de desplazamiento<p className='field__star'>*</p>
                  </span>
                  <input
                    type='text'
                    className='field__input'
                    name='displacementPlace'
                    value={personalInfo.displacementPlace}
                    onInput={({ target }) =>
                      addPersonalInfo(target.name, target.value)
                    }
                  />
                </div>
              </>
            )}
            <div className='section__field field section__field--all-row'>
              <span className='field__text'>Enfoque diferencial</span>
              <label htmlFor='homeless' className='field__multi-select options'>
                <input
                  type='checkbox'
                  id='homeless'
                  checked={personalInfo.homeless}
                  onChange={({ target }) =>
                    addPersonalInfo(target.id, target.checked)
                  }
                />
                <span className='options__checkbox cb'>
                  <span className='cb__icon'></span>
                </span>
                <span className='options__name'>Situación de Calle</span>
              </label>
              <label htmlFor='farmer' className='field__multi-select options'>
                <input
                  type='checkbox'
                  id='farmer'
                  checked={personalInfo.farmer}
                  onChange={({ target }) =>
                    addPersonalInfo(target.id, target.checked)
                  }
                />
                <span className='options__checkbox cb'>
                  <span className='cb__icon'></span>
                </span>
                <span className='options__name'>Campesino</span>
              </label>
            </div>
            <div className='section__field field'>
              <span className='field__text'>
                Condición de discapacidad<p className='field__star'>*</p>
              </span>
              <Select
                field='disability'
                options={disabilities}
                selectedDef={personalInfo.disability}
                setSelected={(param, value, relatedValue) =>
                  addPersonalInfo(param, value, relatedValue)
                }></Select>
            </div>
            <div className='section__field field'>
              <span className='field__text'>
                ¿Tiene alguna enfermedad crónica?
                <p className='field__star'>*</p>
              </span>
              <Select
                field='chronicDisability'
                options={diseases}
                selectedDef={personalInfo.chronicDisability}
                setSelected={(param, value, relatedValue) =>
                  addPersonalInfo(param, value, relatedValue)
                }></Select>
            </div>
            {personalInfo.chronicDisability === KeyConstant.YES && (
              <>
                <div className='section__field field'>
                  <span className='field__text'>Nombre de la enfermedad</span>
                  <input
                    type='text'
                    className='field__input'
                    name='diseaseName'
                    value={personalInfo.diseaseName}
                    onInput={({ target }) =>
                      addPersonalInfo(target.name, target.value)
                    }
                  />
                </div>
                <div className='section__field field'>
                  <span className='field__text'>
                    Tratamiento de la enfermedad
                  </span>
                  <input
                    type='text'
                    className='field__input'
                    name='diseaseTreatment'
                    value={personalInfo.diseaseTreatment}
                    onInput={({ target }) =>
                      addPersonalInfo(target.name, target.value)
                    }
                  />
                </div>
              </>
            )}
          </div>
          <div className='form__section section'>
            <div className='section__field field'>
              <span className='field__text'>
                Problemas y factores de riesgo<p className='field__star'>*</p>
              </span>
              <Select
                field='riskFactor'
                options={risks}
                selectedDef={personalInfo.riskFactor}
                setSelected={(param, value, relatedValue) =>
                  addPersonalInfo(param, value, relatedValue)
                }></Select>
            </div>
          </div>
          <div className='form__terms terms'>
            <label htmlFor='tyc' className='terms__wrapper'>
              <input
                type='checkbox'
                id='tyc'
                onChange={() => setIsCheckedTerms(!isCheckedTerms)}
                checked={isCheckedTerms}
              />
              <span className='terms__checkbox cb'>
                <span className='cb__icon'></span>
              </span>
            </label>
            <span className='terms__text'>
              Acepto las políticas de tratamiento de datos.{' '}
              <a
                href='https://www.medellin.gov.co/normograma/docs/astrea/docs/d_alcamed_1096_2018.htm'
                className='terms__url'>
                Ver Términos y Condiciones
              </a>
            </span>
          </div>
          <div className='form__actions actions'>
            <button className='actions__save' onClick={save}>
              {edit ? 'Editar' : 'Guardar'}
            </button>
            <button className='actions__cancel' onClick={() => navigate('/')}>
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}